import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles, categories } from '@/mocks/articles';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9spapt8o1vn02ekuji0';

export default function CategoryPage() {
  const { categoryId } = useParams<{ categoryId: string }>();

  const category = categories.find((c) => c.id === categoryId);
  const categoryArticles = articles.filter((a) => a.category === categoryId);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-3">分类未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer formUrl={NEWSLETTER_FORM_URL} />
      </>
    );
  }

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: category.label },
  ];

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <div className="mb-8">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
                  <i className={`${category.icon} text-2xl`}></i>
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                    {category.label}
                  </h1>
                  <p className="text-sm text-foreground-500 mt-1">
                    共 {categoryArticles.length} 篇文章
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    cat.id === categoryId
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:text-foreground-900 hover:bg-background-200 border border-background-200/70'
                  }`}
                >
                  {cat.label}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
                  >
                    <div className="relative w-full aspect-[16/9] overflow-hidden">
                      <img
                        src={article.imageUrl}
                        alt={article.title}
                        title={`${article.title} - 亚洲在线`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                        {article.title}
                      </h3>
                      <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-3 text-xs text-foreground-400">
                        <span>{article.date}</span>
                        <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                        <span>{article.readTime}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer formUrl={NEWSLETTER_FORM_URL} />
    </>
  );
}